export default "__VITE_ASSET__1b96c42b__"